document.addEventListener("DOMContentLoaded", function () {
  // Function to open submenu
  function openSubMenu(subMenuId) {
    // Hide all menu items
    document.querySelectorAll(".menu-item").forEach(function (item) {
      item.style.display = "none";
    });

    // Hide main menu header
    // document.querySelector(".menu-header").style.display = "none";
    if (document.querySelector(".js-header-nosto-sale-banner")) {
      document.querySelector(".js-header-nosto-sale-banner").classList.add("flex-order-2");
    }
    if (document.querySelector(".drawer_menu_footer")) {
      document.querySelector(".drawer_menu_footer").style.display = "none";
    }

    // Show the selected submenu
    document.querySelector(subMenuId).style.display = "flex";
    document
      .querySelector(subMenuId)
      .querySelectorAll(".submenu-item")
      .forEach(function (item) {
        item.style.display = "flex";
      });
  }

  // Function to open third-level submenu
  function openThirdSubMenu(thirdSubMenuId) {
    document.querySelectorAll(".submenu").forEach(function (submenu) {
      submenu.style.display = "none";
    });
    // Hide all submenu items
    document.querySelectorAll(".submenu-item").forEach(function (item) {
      item.style.display = "none";
    });

    // Hide all second-level submenu headers
    // document.querySelectorAll(".submenu-header").forEach(function (header) {
    //   header.style.display = "none";
    // });

    // Show the selected third-level submenu items
    document.querySelector(thirdSubMenuId).style.display = "flex";
    document
      .querySelector(thirdSubMenuId)
      .querySelectorAll(".submenu-item")
      .forEach(function (item) {
        item.style.display = "flex";
      });
  }

  // Function to go back to the main menu
  function backToMainMenu() {
    // Hide all submenus
    document.querySelectorAll(".submenu, .third-submenu").forEach(function (submenu) {
      submenu.style.display = "none";
    });

    // Show all menu items
    document.querySelectorAll(".menu-item").forEach(function (item) {
      item.style.display = "flex";
    });

    // Show main menu header
    // document.querySelector(".menu-header").style.display = "flex";
    if (document.querySelector(".js-header-nosto-sale-banner")) {
      document.querySelector(".js-header-nosto-sale-banner").classList.remove("flex-order-2");
    }
    if (document.querySelector(".drawer_menu_footer")) {
      document.querySelector(".drawer_menu_footer").style.display = "flex";
    }
  }

  // Function to go back to the second-level submenu
  function backToSubMenu(parentMenuId) {
    // Hide all third-level submenu items
    document.querySelectorAll(".third-submenu").forEach(function (submenu) {
      submenu.style.display = "none";
    });

    document.querySelector(parentMenuId).style.display = "flex";

    // Show the second-level submenu items
    document
      .querySelector(parentMenuId)
      .querySelectorAll(".submenu-item")
      .forEach(function (item) {
        item.style.display = "flex";
      });

    // Show corresponding second-level submenu header
    document.querySelector(parentMenuId).querySelector(".submenu-header").style.display = "flex";
  }

  // Event listeners for main menu items
  document.querySelectorAll(".menu-item").forEach(function (menuItem) {
    menuItem.addEventListener("click", function () {
      const subMenuId = menuItem.getAttribute("data-submenu-id");
      const hasSubMenu = !menuItem.classList.contains("no-submenu");
      if (subMenuId && hasSubMenu) {
        openSubMenu("#" + subMenuId);
      }
    });
  });

  // Event listeners for second-level submenu items
  document.querySelectorAll(".submenu-item").forEach(function (submenuItem) {
    submenuItem.addEventListener("click", function () {
      const thirdSubMenuId = submenuItem.getAttribute("data-submenu-id");
      if (thirdSubMenuId) {
        openThirdSubMenu("#" + thirdSubMenuId);
      }
    });
  });

  // Event listener for back buttons
  document.querySelectorAll(".back-button").forEach(function (button) {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      const parentMenuId = button.getAttribute("data-parent-menu");
      if (parentMenuId === ".mobile-menu") {
        backToMainMenu();
      } else {
        backToSubMenu(parentMenuId);
      }
    });
  });
});
